import { Field, Message, TextOutput } from 'Components/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection } from 'Components/Layout';
import { IWorksheetComponent } from 'Components/Worksheets/Core';
import { createMessageGetter } from 'Components/Worksheets/Core/Helpers/messageHelpers';
import { hasValue } from 'Lib/Any';
import { combine } from 'Lib/Hooks/Selectors';
import React from 'react';
import { useSelector } from 'react-redux';
import { pipe } from 'rxjs';

let FieldResults: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  // External And Imported messages are the same, but set on different properties.
  const laboratoryMCNotCompleteMessage = useSelector(
    combine(
      [
        pipe(
          createWorksheetSelector!('FieldResults.AssociatedLabMoistureContent.Messages'),
          createMessageGetter('ImportedTest')
        ),
        pipe(
          createWorksheetSelector!('FieldResults.AssociatedLabMoistureContent.Messages'),
          createMessageGetter('ExternalTest')
        ),
      ],
      (m1, m2) => [m1, m2].filter((m) => m?.MessageType === 'info')[0]?.Text
    )
  );

  return (
    <>
      <ListFieldSection heading="Field Results">
        <Field input={<TextOutput />} name="Results.FieldWetDensity" emph />
        <Field input={<TextOutput />} name="Results.ResultMoistureContent" emph />
        <Field input={<TextOutput />} name="Results.DryDensity" emph />
      </ListFieldSection>
      <ListFieldSection visible={hasValue(laboratoryMCNotCompleteMessage)} wide>
        <Message info message={laboratoryMCNotCompleteMessage} />
      </ListFieldSection>
    </>
  );
};

FieldResults = withInjectedProps(FieldResults);

export { FieldResults };
export default FieldResults;
